import {
  requestCertifyPhoneApi,
  requestCheckIdApi,
  requestFindUserId,
  requestChangePassword2
} from "@/apis/certify_api";

import store from "@/store";
import router from "@/router";

const state = {
  idSearchList: null
};

const getters = {
  getIdSearchList(state) {
    return state.idSearchList;
  }
};

const mutations = {
  SEARCH_ID(state, data) {
    state.idSearchList = data.resultSearchIdList;
  },

  SEARCH_ID_INIT(state) {
    state.idSearchList = null;
  }
};

const actions = {
  //new
  async REQUEST_CERTIFY_PHONE({ commit }, parameter) {
    let result = {};

    try {
      commit("START_LOADING");
      const res = await requestCertifyPhoneApi(parameter.param);
      const { data } = res;

      if (data.result !== "success") {
        result.result = false;
        result.message = data.message;
        return alert(data.message);
      }
      result.result = true;
      result.message = data.message;
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
      result.result = false;
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }

    return result;
  },
  async REQUEST_CHECK_ID({ commit }, parameter) {
    let result = {};
    try {
      commit("START_LOADING");
      const res = await requestCheckIdApi(parameter);

      const { data } = res;

      if (data.result !== "success") {
        result.result = false;
        result.message = data.message;
        return result;
      }
      result.result = true;
      result.message = data.message;
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
      result.result = false;
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }

    return result;
  },

  async REQUEST_SEARCH_ID({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestFindUserId(parameter.user);
      const { data } = response;

      if (data?.result !== "success") {
        alert(data.message);
        return router.replace("/login");
      }

      commit("SEARCH_ID", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_CHANGE_PASSWORD2({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestChangePassword2(parameter);

      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }

      alert(data.message);

      const { type } = parameter;
      switch (type) {
        case "funeral":
          store.dispatch("REQUEST_LOGOUT_FUNERAL");
          break;
        case "corp":
          store.dispatch("REQUEST_LOGOUT_CORP");
          break;
        case "director":
          store.dispatch("REQUEST_LOGOUT_DIRECTOR");
          break;

        default:
          break;
      }
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
